export function shortNumberFormat(val: number): [number, string] {
  let valueForFormat: number = Math.floor(val);
  let suffix = '';
  if (val >= 10000000000) {
    valueForFormat = Math.round(val / 1000000000);
    suffix = 'b';
  } else if (val >= 1000000000) {
    valueForFormat = Math.round(val / 100000000) / 10;
    suffix = 'b';
  } else if (val >= 10000000) {
    valueForFormat = Math.round(val / 1000000);
    suffix = 'm';
  } else if (val >= 1000000) {
    valueForFormat = Math.round(val / 100000) / 10;
    suffix = 'm';
  } else if (val >= 10000) {
    valueForFormat = Math.round(val / 1000);
    suffix = 'k';
  } else if (val >= 1000) {
    valueForFormat = Math.round(val / 100) / 10;
    suffix = 'k';
  }
  return [valueForFormat, suffix];
}
